import { store } from 'components/Store';
import { useContext } from 'react';

// A NULL/blank regex means the feature is open to everyone.
const useTranscriptsFeatureEnabled = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;

  const emailRegex = import.meta.env.VITE_APP_TRANSCRIPTS_FEATURE_EMAIL_REGEX;
  const emailAddress = team?.myself?.emailAddress;

  const transcriptsFeatureEnabled = !emailRegex || (!!emailAddress && new RegExp(emailRegex).test(emailAddress));

  return { transcriptsFeatureEnabled };
};

export default useTranscriptsFeatureEnabled;
